import { render, staticRenderFns } from "./floor-style-3.vue?vue&type=template&id=db37c8dc&"
import script from "./floor-style-3.vue?vue&type=script&lang=js&"
export * from "./floor-style-3.vue?vue&type=script&lang=js&"
import style0 from "./floor-style-3.vue?vue&type=style&index=0&id=db37c8dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports